<template>
  <footer>
    <div class="container">
      <div class="footer-links">
        <a href="#" class="fszS">О нас</a>
        <a href="#" class="fszS">Как это работает?</a>
        <a href="#" class="fszS">FAQ</a>
        <a href="#" class="fszS">Blog</a>
      </div>
      <p class="fszS lh17 footer-text">Crezu.ph is a brand of the company Fininity Ltd (registration number: 14523902, address: Tartu Street 84a, Tallinn, 10112, EE.)<br>This site is not a financial institution, bank, or lender. This site finds loans for customers, acting as an intermediary between a client who is looking to take a loan and a licensed financial institution. It is not responsible for any loan agreement. This website does not charge a service fee, nor is it responsible for the actions, inactions, or interest rates of any lender. You are never under any obligation to use the service, initiate contact, or request credit with any lenders this site connects you to.</p>
      <div class="footer-bottom clearfix">
        <ul class="">
          <li class="footer-bottom__link"><a href="terms-and-conditions.html" class="fszS">Terms</a></li>
          <li class="footer-bottom__link"><a href="privacy-policy.html" class="fszS">Privacy</a></li>
          <li class="footer-bottom__link"><a href="cookie-policy.html" class="fszS">Cookies</a></li>
        </ul>
        <p class="footer-bottom__copyright fszS">© <i class="year"></i> Crezu.com</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue